<template>
	<v-currency-field
		:hide-details="hideDetails"
		:error="errorBorder"
		:error-messages="$props.error"
		:label="$props.label"
		:mask="$props.mask"
		:clearable="clearable && !readonly"
		:placeholder="$props.placeholder"
		:readonly="$props.readonly"
		:type="$props.type"
		:disabled="disabled"
		v-bind="currency_config"
		v-model="inputValue"
	>
	</v-currency-field>
</template>

<script>
export default {
	name: 'NumberField',
	props: {
		value: Number,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
		precision: {
			type: Number,
			default: 0,
		},
		placeholder: String,
		label: String,
		type: String,
		mask: String,
		suffix: String,
		readonly: Boolean,
		disabled: Boolean,
		clearable: Boolean,
	},
	data() {
		return {
			inputValue: this.$props.value,
			currency_config: {
				locale: 'fr',
				prefix: '',
				suffix: this.$props.suffix,
				decimalLength: this.$props.precision,
				masked: false,
				allowBlank: false,
				min: Number.MIN_SAFE_INTEGER,
				max: Number.MAX_SAFE_INTEGER,
				defaultValue: null,
			},
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		inputValue() {
			this.$emit('input', this.inputValue);
		},
		value() {
			this.inputValue = this.$props.value;
		},
	},
};
</script>

<style scoped></style>
